module.exports = __webpack_public_path__ + "img/platform1.2c1e97fb.png";